import { jsx as o } from "react/jsx-runtime";
const r = (c) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M32 5.971s-19.504 12.19-19.504 32.426c0 10.772 8.732 19.505 19.504 19.505 10.772 0 19.504-8.733 19.504-19.505C51.504 18.405 32 5.971 32 5.971Zm10.963 43.39A15.403 15.403 0 0 1 32 53.9a15.403 15.403 0 0 1-10.963-4.54 15.403 15.403 0 0 1-4.541-10.964c0-3.995.884-7.971 2.63-11.818 1.431-3.157 3.445-6.245 5.984-9.179a48.476 48.476 0 0 1 6.872-6.498 49.798 49.798 0 0 1 6.897 6.578c2.544 2.954 4.562 6.05 5.996 9.202 1.745 3.834 2.63 7.776 2.63 11.715 0 4.142-1.613 8.035-4.542 10.964ZM32 48.49v2c-6.668 0-12.093-5.425-12.093-12.094h2c0 5.566 4.528 10.093 10.093 10.093Z"
      }
    )
  }
);
export {
  r as Oil
};
